// src/components/management/Chat/ChatList.jsx
import { useEffect, useRef, useState } from "react";
import ChatFilters from "./ChatFilters";
import "../../../styles/components/management/Chat/ChatList.css";
import { useAuth } from "../../../context/AuthContext";
import AISettings from "./AISettings";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function ChatList({ setSelectedBooking }) {
  const { user } = useAuth();
  const [bookings, setBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [unreadMap, setUnreadMap] = useState({});
  const [showSettings, setShowSettings] = useState(false);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const filterIconRef = useRef(null);

  const fetchBookings = async () => {
    const res = await fetch(`${API_BASE}/app/API/rbmgt/chat/bookings.php?activeOnly=1`);
    const data = await res.json();
    if (data.success) {
      setBookings(data.bookings);
      setFilteredBookings(data.bookings);
    }
  };

  const fetchUnread = async () => {
    const res = await fetch(`${API_BASE}/app/API/rbmgt/chat/getUnreadCounts.php`);
    const data = await res.json();
    if (data.success) setUnreadMap(data.counts);
  };

  useEffect(() => {
    fetchBookings();
    fetchUnread();
    const interval = setInterval(() => {
      fetchBookings();
      fetchUnread();
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="chat-list">
      <div className="chat-list-header">
        <button
          ref={filterIconRef}
          className="chat-settings-icon"
          title="Filter Chats"
          onClick={() => setFiltersVisible((prev) => !prev)}
        >
          🔍
        </button>
        <button
          className="chat-settings-icon"
          title="AI Settings"
          onClick={() => setShowSettings(true)}
        >
          ⚙️
        </button>
      </div>

      

      <ChatFilters
        bookings={bookings}
        setFilteredBookings={setFilteredBookings}
        iconRef={filterIconRef}
        collapsed={!filtersVisible}
        setCollapsed={(v) => setFiltersVisible(!v)}
        unreadMap={unreadMap}
      />

      {showSettings && <AISettings onClose={() => setShowSettings(false)} />}

      <ul className="chat-list-scroll">
        {filteredBookings.map((b) => {
          const idStr = String(b.ID);
          const unreadCount = unreadMap[idStr] || 0;

          return (
            <li
              key={b.ID}
              onClick={() => setSelectedBooking(b)}
              className="chat-list-item"
            >
              <div className="platform-badge">
                {b.PLATFORM === "Booking.com" && <img src="/icons/bookingcom.png" alt="Booking.com" />}
                {b.PLATFORM === "Airbnb" && <img src="/icons/airbnb.png" alt="Airbnb" />}
                {b.PLATFORM === "zan.investments.bnb" && <img src="/logo.png" alt="Direct Booking" />}
              </div>
              <div className="chat-list-entry">
                <div className="chat-info">
                  <strong>#{b.ID} – {b.GUEST_NAME || "Guest"}</strong><br />
                  {b.CHECK_IN_DATE} – {b.CHECK_OUT_DATE}<br />
                  {b.UNIT_NAME}
                </div>
                <div className="chat-meta">
                  {unreadCount > 0 && (
                    <span className="unread-badge">{unreadCount}</span>
                  )}
                  <div className="status-line">
                    <span className={`booking-status ${b.STATUS?.toLowerCase()}`}>
                      {b.STATUS}
                    </span>
                    {b.SUB_STATUS && b.SUB_STATUS.toLowerCase() !== "none" && (
                      <span className="booking-substatus"> – {b.SUB_STATUS}</span>
                    )}
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
